// extracted by mini-css-extract-plugin
module.exports = {"item":"SectionBlog_item__dgNp5"};